export default {
  init() {
    $('.order-line .reason-select select').select2({
      minimumResultsForSearch: Infinity,
      dropdownParent: $('.order-line'),
      width: '100%',
    });

    $('.order-line .return-unit-checkbox').on('change', function () {
      let form = $(this).closest('form');
      let $unitContainer = $(this).closest('.order-line');
      let $reasonSelect = $unitContainer.find('.return-reason-select');
      const isChecked = $(this).is(':checked');

      $reasonSelect.prop('disabled', !isChecked).trigger('change.select2');

      updateReturnForm(form);
    });

    $('.order-line .return-reason-select').on('change', function () {
      let form = $(this).closest('form');
      updateReturnForm(form);
    });

    $('.order .return-cancel').click(function () {
      let form = $(this).closest('form');
      form.find('.return-unit-checkbox:not(:disabled)').prop('checked', false).trigger('change');
    });

    $('.order').each(function () {
      let form = $(this).closest('form');
      updateReturnForm(form);
    });

    $('.return-submit').on('click', function() {
      setTimeout(() => {
        $(this).prop('disabled', true);
      }, 100);
    });
  },
  finalize() {
    // Any JS that should fire after init
  },
};

export var updateReturnForm = (form) => {
  let totalQuantity = 0;

  form.find('.order-line').each(function() {
    let $unitContainer = $(this);
    let $checkbox = $unitContainer.find('.return-unit-checkbox');
    let $reasonSelect = $unitContainer.find('.return-reason-select');

    let unitKey = $unitContainer.data('unit-key');

    if ($checkbox.is(':checked')) {
      totalQuantity += 1;
      form.find('.consolidated-qty-' + unitKey).val(1);
      form.find('.consolidated-reason-' + unitKey).val($reasonSelect.val() || '');
    } else {
      form.find('.consolidated-qty-' + unitKey).val(0);
      form.find('.consolidated-reason-' + unitKey).val('');
    }
  });

  let submitBar = form.find('.submit-bar');
  submitBar.find('.return-counter .counter').text(totalQuantity);

  if (totalQuantity > 0) {
    submitBar.slideDown();
  } else {
    submitBar.slideUp();
  }
};
